export default __webpack_public_path__ + "static/media/scotiabank-1.11485703.JPG";